import React, { useState, useEffect } from "react";
import { userService } from "../../_services";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search } from "lucide-react";

/**
 * Group Number Summary Widget
 * Modernized with shadcn components - Shows group numbers and compensation plan
 */
function Groupno_summary({ groupnumber }) {
    const [groupNumberList, setGroupNumberList] = useState(groupnumber || []);
    const [filterText, setFilterText] = useState('');

    useEffect(() => {
        if (!groupnumber || groupnumber.length === 0) {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = Usermeta_Data.split(':');
            getUserSummaryDetails(userId, userName);
        } else {
            setGroupNumberList(groupnumber);
        }
    }, [groupnumber]);

    const getUserSummaryDetails = async (userId, userName) => {
        try {
            const apidata = await userService.GetUserSummaryDetail(userId, userName);
            if (apidata && apidata.length > 0) {
                setGroupNumberList(apidata[0].groupNumber || []);
            }
        } catch (error) {
            console.error('Error fetching user summary:', error);
        }
    };

    const handleSearchFilter = (e) => {
        const val = e.target.value.toLowerCase();
        setFilterText(val);
    };

    const showemail = userService.getemail();
    const filteredGroupNumbers = groupNumberList.filter(uitem => 
        !filterText || uitem.value.toLowerCase().includes(filterText)
    );

    const compensationTiers = [
        { transactions: '0-1499', commission: '$1.50' },
        { transactions: '1500-2000', commission: '$1.75' },
        { transactions: '> 2000', commission: '$2.00' }
    ];

    return (
        <div className="space-y-4">
            {/* Group Numbers Card */}
            <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="text-lg font-semibold text-primary">
                        Group Numbers
                    </CardTitle>
                    <a href={`mailto:${showemail}`}>
                        <Button variant="ghost" size="sm" className="text-accent hover:text-accent/80 hover:bg-muted">
                            Request More
                        </Button>
                    </a>
                </CardHeader>
                <CardContent>
                    {groupNumberList && groupNumberList.length > 0 ? (
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <p className="text-sm text-primary/70">
                                    Total Group Numbers: <span className="font-semibold text-primary">{groupNumberList.length}</span>
                                </p>
                            </div>
                            
                            <div className="relative mb-2">
                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-primary/50" />
                                <Input
                                    type="text"
                                    placeholder="Search group number..."
                                    onChange={handleSearchFilter}
                                    className="pl-10"
                                />
                            </div>

                            <ul className="max-h-60 overflow-y-auto divide-y divide-border">
                                {filteredGroupNumbers.map((uitem, index) => (
                                    <li key={index+1} className={`px-3 py-2 text-sm text-foreground ${index+1 % 2 === 1 ? 'bg-muted' : ''}`}>
                                        {uitem.value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <p className="text-sm text-primary/70">No group numbers assigned yet.</p>
                    )}
                </CardContent>
            </Card>

            {/* Compensation Plan Card */}
            <Card>
                <CardHeader>
                    <CardTitle className="text-lg font-semibold text-primary">
                        Compensation Plan
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="border rounded-md overflow-hidden">
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead className="text-primary">Transactions</TableHead>
                                    <TableHead className="text-primary text-right">Commission ($)</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {compensationTiers.map((tier, index) => (
                                    <TableRow key={index}>
                                        <TableCell className="font-medium text-primary">{tier.transactions}</TableCell>
                                        <TableCell className="text-right font-semibold text-accent">{tier.commission}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>

                    <p className="text-xs text-primary/70">
                        Eligibility for higher compensation tiers is granted on a case by case basis. Please{' '}
                        <a 
                            href="mailto:support@nulifespanrx.com" 
                            className="text-accent hover:no-underline hover:text-foreground font-medium"
                        >
                            get in touch
                        </a>{' '}
                        with an administrator to learn more.
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}

export default Groupno_summary;
